import { useState, useRef, useEffect } from "react";

// Divided by 4 because the base animation is really fast
// and cannot be slowed by the library only increased
const ANIMATION_SLOWER_SPEED = 4;

// 600px because we need to start the animation sooner than when the element has almost disappeared
const ANIMATION_OFFSET_TO_SCREEN = 600;

export const useGetLottieScrollPosition = <T extends HTMLElement>() => {
  const [animationStartFrame, setAnimationStartFrame] = useState(0);
  const animationContainerRef = useRef<T>(null);

  const handleScroll = () => {
    const screenPosition = window.pageYOffset;
    const animationFrame =
      (screenPosition -
        (Number(animationContainerRef.current?.offsetTop) -
          ANIMATION_OFFSET_TO_SCREEN)) /
      ANIMATION_SLOWER_SPEED;

    // Reduce renders and prevent animation from not being shown
    setAnimationStartFrame(animationFrame < 1 ? 1 : animationFrame);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return { animationContainerRef, animationStartFrame };
};
